// Configuration for artcast display
export const ARTCAST_CONFIG = {
    MAX_DISPLAY_COUNT: 15, // Maximum number of artcasts to display in selection
    // Can add other related config here in the future
} as const;
